export default __webpack_public_path__ + "static/media/linux.13d04317.svg";